/** ACT004 数据热点（type=9）运行时归一化（与控制台 act004-data-hotspot.js 口径一致） */

export const ACT004_DATA_HOTSPOT_FONT_OPTIONS = [
  { label: '系统默认', value: 'DEFAULT' },
  { label: '苹方', value: 'PINGFANG' },
  { label: '微软雅黑', value: 'MICROSOFT_YAHEI' },
  { label: 'Arial', value: 'ARIAL' },
  { label: 'Helvetica', value: 'HELVETICA' },
  { label: 'Impact 粗体', value: 'IMPACT' },
  { label: 'DIN1451 数字', value: 'DIN1451' }
]

export const ACT004_DATA_HOTSPOT_FONT_STACK = {
  DEFAULT: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif',
  PINGFANG: '"PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif',
  MICROSOFT_YAHEI: '"Microsoft YaHei", "PingFang SC", sans-serif',
  ARIAL: 'Arial, sans-serif',
  HELVETICA: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  IMPACT: 'Impact, "Arial Black", sans-serif',
  DIN1451: '"Act004DIN1451", "DIN", "D-DIN", "DIN Alternate", "Arial Narrow", Impact, sans-serif'
}

export const ACT004_DIN1451_FONT_URL = 'https://wvxvb.cn/font/DIN1451.ttf'
export const ACT004_DIN1451_FONT_FAMILY = 'Act004DIN1451'

let _din1451FontLoadPromise = null

export function normalizeAct004DataType(raw) {
  const v = String(raw || '').trim()
  if (v === 'CHECKIN_POINT_RANK') return 'CHECKIN_POINT_RANK'
  if (v === 'ACTIVITY_USER_JOIN_TIME') return 'ACTIVITY_USER_JOIN_TIME'
  if (v === 'USER_LOTTERY_CHANCE') return 'USER_LOTTERY_CHANCE'
  return 'USER_ACTIVITY_POINTS'
}

export function normalizeAct004DataBindPointIndex(raw, dataType) {
  if (normalizeAct004DataType(dataType) !== 'CHECKIN_POINT_RANK') return null
  const n = parseInt(raw, 10)
  return Number.isFinite(n) && n > 0 ? n : null
}

export function normalizeAct004DataFontSize(raw) {
  const n = parseInt(raw, 10)
  return Number.isFinite(n) ? Math.max(12, n) : 30
}

export function normalizeAct004DataFontFamily(raw) {
  const v = String(raw || '').trim().toUpperCase()
  if (v === 'RANXI_DIN') return 'DIN1451'
  const allowed = ACT004_DATA_HOTSPOT_FONT_OPTIONS.map((o) => o.value)
  if (allowed.includes(v)) return v
  return 'DEFAULT'
}

export function normalizeAct004DataFontBold(raw) {
  if (raw == null || raw === '') return 1
  return raw === 1 || raw === true || raw === '1' ? 1 : 0
}

export function normalizeAct004DataFontColor(raw) {
  const s = String(raw == null ? '' : raw).trim()
  if (!s) return '#000000'

  const hex6Match = s.match(/^#?([0-9a-fA-F]{6})$/)
  if (hex6Match) return `#${hex6Match[1]}`.toUpperCase()

  const hex3Match = s.match(/^#?([0-9a-fA-F]{3})$/)
  if (hex3Match) {
    const h = hex3Match[1]
    return `#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`.toUpperCase()
  }

  const rgbMatch = s.match(/^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/i)
  if (rgbMatch) {
    const toHex = (n) => {
      const v = Math.max(0, Math.min(255, Math.round(parseFloat(n))))
      return v.toString(16).padStart(2, '0')
    }
    return `#${toHex(rgbMatch[1])}${toHex(rgbMatch[2])}${toHex(rgbMatch[3])}`.toUpperCase()
  }

  return '#000000'
}

export function resolveAct004DataHotspotFontFamilyCss(raw) {
  const key = normalizeAct004DataFontFamily(raw)
  return ACT004_DATA_HOTSPOT_FONT_STACK[key] || ACT004_DATA_HOTSPOT_FONT_STACK.DEFAULT
}

/** 预加载活动页数字字体 DIN1451（与小程序 App.vue 一致） */
export function ensureAct004Din1451FontLoaded() {
  if (typeof document === 'undefined') return Promise.resolve()
  try {
    if (document.fonts && document.fonts.check(`16px "${ACT004_DIN1451_FONT_FAMILY}"`)) {
      return Promise.resolve()
    }
  } catch (e) {
    /* ignore */
  }
  if (_din1451FontLoadPromise) return _din1451FontLoadPromise
  _din1451FontLoadPromise = new Promise((resolve) => {
    if (typeof FontFace === 'undefined') {
      resolve()
      return
    }
    const font = new FontFace(ACT004_DIN1451_FONT_FAMILY, `url(${ACT004_DIN1451_FONT_URL})`)
    font.load()
      .then((loaded) => {
        document.fonts.add(loaded)
        resolve()
      })
      .catch(() => resolve())
  })
  return _din1451FontLoadPromise
}

export function pickAct004DataHotspotFields(h) {
  const src = h && typeof h === 'object' ? h : {}
  const dataType = normalizeAct004DataType(src.dataType)
  return {
    dataType,
    dataBindPointIndex: normalizeAct004DataBindPointIndex(src.dataBindPointIndex, dataType),
    dataFontSize: normalizeAct004DataFontSize(src.dataFontSize),
    dataFontFamily: normalizeAct004DataFontFamily(src.dataFontFamily),
    dataFontBold: normalizeAct004DataFontBold(src.dataFontBold),
    dataFontColor: normalizeAct004DataFontColor(src.dataFontColor)
  }
}

export function collectAct004DataHotspotFontFamilyKeysFromPages(pages) {
  const set = new Set()
  const walk = (list) => {
    if (!Array.isArray(list)) return
    list.forEach((h) => {
      if (!h || String(h.type) !== '9') return
      set.add(normalizeAct004DataFontFamily(h.dataFontFamily))
    })
  }
  if (Array.isArray(pages)) {
    pages.forEach((p) => walk(p && p.hotspots))
  }
  return Array.from(set)
}

export function preloadAct004DataHotspotFontsForPages(pages) {
  const keys = collectAct004DataHotspotFontFamilyKeysFromPages(pages)
  if (keys.includes('DIN1451')) {
    return ensureAct004Din1451FontLoaded()
  }
  return Promise.resolve()
}
